var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "669px",
    height: "629px",
    viewBox: "0 0 669 629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 906.4875,
    y1: 357.15000000000003,
    x2: 64.91249999999997,
    y2: 313.05,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8B6538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#452F25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: 525.6875,
    y1: 485.8875,
    x2: 119.8125,
    y2: 80.01249999999999,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DFDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: -105.8125,
    y1: 478.27500000000003,
    x2: -180.6875,
    y2: 379.325,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 823.575,
    y1: 499.4125,
    x2: 849.625,
    y2: 531.2875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#452F25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 482.6625,
    y1: 122.72500000000001,
    x2: 482.5375,
    y2: 59.175,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8B6538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#452F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 5.037500000000001,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix( 0.9999999999999998, 0, 0, 0.9999999999999998, 5,5) ",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_7",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 20.287500000000023,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix( 0.999999999999999, 0, 0, 1.113370301910042, 675.5,441.55) ",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0000FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_8",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2375,
    y1: 305.0375,
    x2: 513.7625,
    y2: 290.0625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_9",
    gradientUnits: "userSpaceOnUse",
    x1: 444.55,
    y1: 430.25,
    x2: 474.65000000000003,
    y2: 430.25,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#452F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.588235294117645%",
    stopColor: "#B0804A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#827166"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_10",
    gradientUnits: "userSpaceOnUse",
    x1: 252.6375,
    y1: 552.75,
    x2: 532.2625,
    y2: 552.75,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#452F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.588235294117645%",
    stopColor: "#B0804A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#827166"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_11",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6875,
    y1: 575.7,
    x2: 304.61249999999995,
    y2: 418.2,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.39215686274509803%",
    stopColor: "#EDAE03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "94.50980392156863%",
    stopColor: "#B0804A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_12",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 39.93596436797288,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix( 0.9972214426337512, -0.07449425717100841, 0.055088190176880165, 0.7349265371324695, 437.65,560.8) ",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#006600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_13",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 39.93596436797288,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix( 0.9972214426337512, -0.07449425717100841, 0.055088190176880165, 0.7349265371324695, 380.3,448.7) ",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0000FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_14",
    gradientUnits: "userSpaceOnUse",
    x1: 433.775,
    y1: 485.45,
    x2: 481.125,
    y2: 485.45,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#452F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.588235294117645%",
    stopColor: "#B0804A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#827166"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_15",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 39.93596436797288,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix( 0.9972214426337512, -0.07449425717100841, 0.055088190176880165, 0.7349265371324695, 333.2,530.8) ",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#957044",
    stroke: "none",
    d: " M 838.5 656.4 L 838.5 680.05 862.15 680.05 862.15 680 862.15 657 862.15 656.4 838.85 656.4 838.5 656.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#866136",
    stroke: "none",
    d: " M 933.4 601.5 L 909.75 601.5 838.85 656.4 862.15 656.4 862.15 657 933.4 601.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B88C58",
    stroke: "none",
    d: " M 933.2 624.65 L 933.4 601.5 862.15 657 862.15 680 866.5 676.6 888.1 659.8 933.2 624.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_1_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B88C58",
    stroke: "none",
    d: " M 738.35 520.65 L 728.1 530.4 728.1 692.6 728.25 692.6 738.35 684.3 738.35 520.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#957044",
    stroke: "none",
    d: " M 728.1 530.4 L 710.05 530.4 710.05 692.6 728.1 692.6 728.1 530.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_2_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B88C58",
    stroke: "none",
    d: " M 455.1 477.8 L 444.85 487.55 444.85 649.75 445 649.75 455.1 641.45 455.1 477.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#957044",
    stroke: "none",
    d: " M 444.85 487.55 L 426.8 487.55 426.8 649.75 444.85 649.75 444.85 487.55 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    stroke: "none",
    d: " M 887.7 574.75 L 907.2 95.4 334.7 95.4 315.2 486.35 887.7 574.75 M 862.3 488.5 L 862.3 488.5 861.85 498.3 Q 862.1130859375 498.3705078125 862.35 498.45 L 862.35 498.5 815.1 535.55 Q 815.537890625 534.637890625 815.95 533.7 L 338.4 465.2 359.2 118.6 372 118.75 878.85 125.05 862.3 488.5 M 859.35 539.95 L 857.2 539.65 859.35 539.85 859.35 539.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_2)",
    stroke: "none",
    d: " M 832.9 487.5 Q 836.25 489.1 843.9 491.95 852.436328125 495.1205078125 861.85 498.3 L 862.3 488.5 862.3 488.5 878.85 125.05 372 118.75 359.2 118.6 338.4 465.2 815.95 533.7 Q 821.4685546875 522.1341796875 826.15 510.5 833.3 492.65 832.9 487.5 M 401.4 463.55 L 401.45 463.6 401.4 463.6 401.4 463.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_3)",
    stroke: "none",
    d: " M 401.45 463.6 L 401.4 463.55 401.4 463.6 401.45 463.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_4)",
    stroke: "none",
    d: " M 843.9 491.95 Q 836.25 489.1 832.9 487.5 833.3 492.65 826.15 510.5 821.4685546875 522.1341796875 815.95 533.7 815.537890625 534.637890625 815.1 535.55 L 862.35 498.5 862.35 498.45 Q 862.1130859375 498.3705078125 861.85 498.3 852.436328125 495.1205078125 843.9 491.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B88C58",
    stroke: "none",
    d: " M 921.35 81.25 L 907.2 95.4 887.7 574.75 900.65 564.55 921.35 81.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_5)",
    stroke: "none",
    d: " M 907.2 95.4 L 921.35 81.25 354.05 86.45 334.7 95.4 907.2 95.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dot_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_6)",
    stroke: "none",
    d: " M 10 5 Q 10 2.9 8.55 1.45 7.1 0 5 0 2.95 0 1.5 1.45 0 2.9 0 5 0 7.1 1.5 8.55 2.95 10 5 10 7.1 10 8.55 8.55 10 7.1 10 5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_4_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#957044",
    stroke: "none",
    d: " M 838.5 656.4 L 838.5 680.05 862.15 680.05 862.15 680 862.15 657 862.15 656.4 838.85 656.4 838.5 656.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#866136",
    stroke: "none",
    d: " M 933.4 601.5 L 909.75 601.5 838.85 656.4 862.15 656.4 862.15 657 933.4 601.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B88C58",
    stroke: "none",
    d: " M 933.2 624.65 L 933.4 601.5 862.15 657 862.15 680 866.5 676.6 888.1 659.8 933.2 624.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_7_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00FF00",
    stroke: "none",
    d: " M 463.15 245.7 Q 460.35 239.6 453.95 232.7 447 225.15 435.95 226.1 424.9 227.1 420.35 235.55 419.8 236.65 417.7 241.9 L 417.7 247.9 Q 420.2 259.15 431.75 261.55 438.6 262.95 442.1 262.8 465.55 261.75 484.25 265.9 469.55 259.35 463.15 245.7 M 438.15 232.7 Q 435.6 233.75 426.05 237.3 427.35 233 431.05 230.7 434.6 228.55 437.35 229.9 437.95 230.15 438.15 232.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_7)",
    stroke: "none",
    d: " M 682.25 443.5 Q 684.65 432.35 679.6 424.25 669.9 408.8 652.7 400.55 648.05 398.35 644.95 400.5 641.85 402.65 642.15 407.9 643 420.7 643.9 426.2 645.85 437.85 647.3 441.75 650.45 449.9 657.7 453.9 L 671.7 453.9 Q 676.5 451.3 678.25 449.9 681.45 447.2 682.25 443.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_8)",
    stroke: "none",
    d: " M 727.7 218.9 Q 721.4 207.1 708.75 207.5 696.2 207.9 688.3 220.05 683.35 227.65 680.8 231.25 676.45 237.35 672.4 241.75 666.55 248.15 657.35 251.8 650.65 254.5 646.4 251.55 642.2 248.7 641.75 241.35 641.6 239.2 642 235.65 642.45 231.3 642.5 229.95 642.65 225.25 641.1 224.2 639.6 223.1 635 224.6 633.9 225 631.75 225.9 629.6 226.8 628.5 227.15 628 227.3 622.6 228.55 623.35 225.5 623.65 224.2 624.2 222 624.8 220.75 625.9 218.6 628.1 214.9 630.55 210.75 631.45 209.05 634.1 204.15 632.2 200.75 630.3 197.3 624.7 197.05 621.2 196.85 618.75 197.25 611.05 198.4 608.5 203.1 606 207.8 609.25 214.85 609.75 215.95 610.9 218 611.8 219.85 612.05 221.25 612.3 222.6 612 224.15 611.7 225.85 610.9 226.45 609.85 227.25 608.05 227.45 606.25 227.65 605.1 227.05 603.5 226.25 601.75 224.6 600.8 223.7 598.85 221.55 596.1 218.35 593.45 217.4 590.3 216.2 586.6 217.75 581.15 220 579.35 213.3 575.4 197.95 579.3 183.75 579.8 181.95 579.4 178.95 578.85 175.55 578.7 173.85 L 570.7 173.9 Q 569.1 176.8 569.2 180.2 569.2 182.8 570.35 186.75 573.9 199.6 576.85 215.3 578.4 222.95 571.8 223.95 567.9 224.5 565.8 223.05 563.75 221.65 562.45 217.45 562 215.95 560.85 213.65 558.95 209.8 558.8 209.5 556.45 212.1 556.8 214.2 557 215.75 559.05 217.9 563.5 222.7 562.8 226.9 562.15 231.05 556.45 234 551.65 236.45 546.55 234.05 541.5 231.65 540.4 226.45 538.5 216.65 537.25 211.85 536.35 208.55 534.9 206.95 533.05 204.9 529.85 205.15 528.45 205.3 527.15 205.75 525.7 206.3 525.2 207.1 524.7 207.95 524.95 209.55 525.2 211.1 525.9 212.1 527.45 214.35 530.65 218.5 534 222.8 535.45 224.9 538.9 229.95 540.15 233.6 543.45 243.55 537.1 251 528 261.75 515.2 265.9 501.6 270.4 487.15 266.1 490.7 268.15 491.35 268.4 492.35 268.85 497 270.55 500.4 271.8 502.45 272.85 506.35 274.85 507.8 278.55 509.25 282.3 507 284.8 502.15 290.25 502.65 295.15 503.05 299.7 508.15 304.95 511.45 308.35 511.4 312.8 511.3 316.95 508.3 321.45 505.15 326.2 502.85 327 500.55 327.8 494.4 326.45 487.1 324.85 482.6 324.9 477.6 324.95 474.4 328.7 471.2 332.45 471.6 337.65 471.95 342.35 475.45 345.3 479 348.3 483.95 348.1 488 347.95 491.4 345.45 493.75 343.7 496.9 339.8 498.45 337.95 501.45 334.15 504.1 330.9 506.3 328.9 507.4 327.9 509.55 327.5 511.7 327.1 512.9 327.75 519.4 331.35 519.9 339.2 520.35 347 514.5 351.75 513.55 352.55 512.4 354.05 511.25 355.7 510.7 356.35 509 356.7 508.15 356.9 506.65 357.25 505.7 357.65 505.4 357.8 505.25 358.9 505.15 360 505.4 360.15 507.7 361.65 507.95 361.8 509.5 362.65 510.5 362.45 513 362 515.8 358.8 516.4 358.15 516.85 356.65 517.4 354.65 517.6 354.2 519.2 350.95 521.15 350.3 523.25 349.6 525.95 351.6 527.85 353.05 531.05 356.55 534.3 360.15 536.1 361.55 537.55 362.7 540.15 363.7 541.65 364.3 544.6 365.4 546.15 359.2 546.25 358.75 546.3 358.4 546.2 357.8 546.05 356.95 546.05 356.8 545.8 353.85 547.1 352.45 548.5 350.95 551.25 351.4 558.15 352.4 564.2 354.65 566.65 355.5 567.4 357.5 568.1 359.45 566.8 362 564.2 367 562.8 369.45 L 559.95 374.05 Q 558.25 376.8 557.4 378.75 556.25 381.3 557.05 383.4 557.85 385.5 560.5 386.55 565.3 388.4 567.4 382.65 568.1 380.85 568.3 377.35 568.35 376.25 568.4 372.6 568.4 369.65 568.65 367.85 569.05 364.65 570.7 362.9 572.45 361.05 575.9 360.4 583.5 359.1 588.25 365.35 594.05 361.7 598.25 363.7 602.45 365.65 602.85 372.15 603 374.7 602.75 378.65 602.35 384.7 602.35 385.1 602.25 388.65 601.8 395.8 601.55 402.1 602.05 406.4 602.7 411.6 607.5 414.15 612.2 416.65 617.4 414.9 624.25 412.65 625.95 406.85 627.65 400.95 623.05 394.9 620.6 391.7 615.95 386.9 610.25 380.95 608.6 379.05 604.3 374 605.4 368.55 606.5 363 612.5 360.55 615.75 359.2 619.4 358.75 623.15 358.3 626.4 358.9 629.85 359.5 633.4 361.35 636.75 363.05 639.55 365.5 645.2 370.45 652.85 377.9 657.15 382.15 665.8 390.65 669.85 394.55 673.25 396.4 677.6 398.8 682.35 398.85 689.9 398.95 691.35 392.75 692.1 389.3 690.45 386.25 688.75 383.15 685.35 381.95 683.85 381.45 680.75 380.9 677.55 380.35 676.1 379.9 666.85 377.3 662.25 375.9 654.15 373.4 649 370.65 641.3 366.5 640.65 361.2 640 356.1 645.75 349.05 649.7 344.25 649 340.85 648.3 337.4 642.65 334.65 639.4 333.05 633.55 330.6 626.9 327.9 624.35 326.7 620.6 324.95 618.8 323.9 615.75 322.2 613.75 320.45 610.8 317.8 610.8 314.1 610.8 310.5 613.45 307.95 618.35 303.25 624.45 304.75 630.55 306.25 632.65 312.75 633.1 314.1 633.7 316.65 634.35 319.3 634.7 320.5 636.95 328 645.1 327.9 652.2 327.85 657.65 323.75 663.15 319.65 665.6 312.45 668.5 304.1 666.95 298.4 665.4 292.7 658.9 287.75 655.8 285.5 654.25 284.4 651.45 282.4 649.8 280.8 648.6 279.65 647.7 278.1 646.75 276.35 647.1 275.45 647.65 274.15 649.3 273 651 271.8 652.35 271.85 655.4 271.9 659.9 272.55 662.4 272.95 667.4 273.7 669.95 274.05 674.95 274.9 679.45 275.6 682.5 275.4 685.65 275.2 687.6 272.85 689.55 270.55 689.55 267.05 689.55 263.95 687.3 262.3 685.4 260.85 682.45 260.9 679.9 260.9 676.25 261.75 672.1 262.8 670 263.2 664.85 264.35 662.3 264.9 657.7 265.85 654.55 266.1 653.45 266.2 651.7 264.8 649.75 263.05 648.75 262.4 649.4 261.5 650.6 259.5 651.65 257.85 652.7 257.2 663.15 250.85 670.8 247.55 675.2 245.65 682.4 245.3 685.8 245.15 690.85 245.35 693.7 245.45 699.35 245.65 713.3 245.95 721.45 235.1 723 233.05 724.75 229.65 727.65 224.05 727.7 223.9 L 727.7 218.9 M 707.25 213.4 Q 705.35 214.55 704.4 215.1 702.75 216.1 701.45 216.55 700.9 216.75 699.85 216.4 698.7 216 698.1 215.85 698.6 214.6 698.85 214 699.25 212.9 699.75 212.7 701.1 212.2 703.1 211.9 704.25 211.7 706.55 211.35 L 707.25 213.4 M 621.95 200.55 L 611.6 204.55 Q 613.4 200.25 615.65 199.4 617.95 198.5 621.95 200.55 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_8_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_9)",
    stroke: "none",
    d: " M 474.6 411.3 L 474.35 410.2 474.25 410.1 Q 472.8 417.5 466.05 423.5 465.3 424.15 464.5 424.8 L 456.65 429.65 456.7 429.75 Q 450.25 433 446.95 438.65 443.6 444.4 444.85 450.25 L 444.95 450.55 Q 445.95 446.25 448.95 442.6 452.05 438.85 456.7 436.55 L 456.65 436.5 Q 456.7 436.5 466.1 429.25 475.35 420.35 474.6 411.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_10)",
    stroke: "none",
    d: " M 254.5 523.8 Q 253 516.5 252.75 508.85 252.75 509.5 252.75 510.15 252.4 520.55 254.5 530.65 259.05 553.3 274.1 571.65 288.6 589.35 310.8 600.65 357.8 624.5 414.9 612 465.05 601.05 498.15 566.8 530.85 533.05 532.3 492.15 L 532.1 490.15 532 489.5 Q 528.9 529.3 496.5 561.7 463.65 594.55 414.9 605.15 357.8 617.65 310.8 593.85 288.6 582.5 274.1 564.8 259.05 546.45 254.5 523.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_11)",
    stroke: "none",
    d: " M 455.45 386.85 L 446.15 384.2 446.3 384.2 Q 409.45 374.7 370 383.25 312.9 395.8 279.05 437.2 263.05 456.75 256.6 479 252.1 494.6 252.75 510.15 252.75 509.5 252.75 508.85 253 516.5 254.5 523.8 259.05 546.45 274.1 564.8 288.6 582.5 310.8 593.85 357.8 617.65 414.9 605.15 463.65 594.55 496.5 561.7 528.9 529.3 532 489.5 L 532.1 490.15 Q 532.2 488.15 532.3 486.2 530.65 468.45 527 458.55 L 523.6 452.2 Q 510.95 435.55 496.6 443.35 492.15 445.7 488.1 450.25 L 484.95 454.35 Q 482.3 458.4 476.25 460.95 L 470.8 462.7 Q 461.65 464.85 454.1 461.2 446.5 457.55 444.85 450.25 443.6 444.4 446.95 438.65 450.25 433 456.7 429.75 L 456.65 429.65 466.05 423.5 Q 472.8 417.5 474.25 410.1 L 474.35 410.2 Q 474.9 407.35 474.6 404.45 474.15 401.7 471.5 398.05 466.2 390.85 455.45 386.85 M 320.35 554 Q 303.25 554 291.15 544.55 279.1 535.1 279.1 521.75 279.1 508.4 291.15 498.95 303.25 489.5 320.35 489.5 337.45 489.5 349.5 498.95 361.6 508.4 361.6 521.75 361.6 535.1 349.5 544.55 337.45 554 320.35 554 M 433.9 494.35 Q 434.25 490.5 436.55 486.85 440.4 480.55 448.4 476.35 457.9 471.35 467.3 471.9 477 472.55 480 478.75 481.1 481 481.2 483.65 481.65 488.4 478.65 494 474.15 501.9 464.85 506.75 455.55 511.7 446.8 510.7 438.1 509.6 435 503.3 432.9 499 433.9 494.35 M 367.45 407.4 Q 384.55 407.4 396.6 416.85 408.7 426.3 408.7 439.65 408.7 453 396.6 462.45 384.55 471.9 367.45 471.9 350.35 471.9 338.25 462.45 326.2 453 326.2 439.65 326.2 426.3 338.25 416.85 350.35 407.4 367.45 407.4 M 395.6 574.55 Q 383.55 565.1 383.55 551.75 383.55 538.4 395.6 528.95 407.7 519.5 424.8 519.5 441.9 519.5 453.95 528.95 466.05 538.4 466.05 551.75 466.05 565.1 453.95 574.55 441.9 584 424.8 584 407.7 584 395.6 574.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_12)",
    stroke: "none",
    d: " M 383.55 551.75 Q 383.55 565.1 395.6 574.55 407.7 584 424.8 584 441.9 584 453.95 574.55 466.05 565.1 466.05 551.75 466.05 538.4 453.95 528.95 441.9 519.5 424.8 519.5 407.7 519.5 395.6 528.95 383.55 538.4 383.55 551.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_13)",
    stroke: "none",
    d: " M 396.6 416.85 Q 384.55 407.4 367.45 407.4 350.35 407.4 338.25 416.85 326.2 426.3 326.2 439.65 326.2 453 338.25 462.45 350.35 471.9 367.45 471.9 384.55 471.9 396.6 462.45 408.7 453 408.7 439.65 408.7 426.3 396.6 416.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_14)",
    stroke: "none",
    d: " M 436.55 486.85 Q 434.25 490.5 433.9 494.35 433.55 496.7 434 499.2 437.3 488.95 447.8 483.5 457.25 478.55 466.65 479.1 476.35 479.65 479.35 485.85 480.1 487.5 480.35 489.05 481.2 486.15 481.2 483.65 481.1 481 480 478.75 477 472.55 467.3 471.9 457.9 471.35 448.4 476.35 440.4 480.55 436.55 486.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_15)",
    stroke: "none",
    d: " M 291.15 544.55 Q 303.25 554 320.35 554 337.45 554 349.5 544.55 361.6 535.1 361.6 521.75 361.6 508.4 349.5 498.95 337.45 489.5 320.35 489.5 303.25 489.5 291.15 498.95 279.1 508.4 279.1 521.75 279.1 535.1 291.15 544.55 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_MEMBER_3_1_STROKES",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 401.45 463.6 L 401.425 463.575 401.425 463.6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.9954376220703125, 0.0954132080078125, -0.0954132080078125, 0.9954376220703125, -643.6,-173.3) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -252.65,-81.25) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_1_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -252.65,-81.25) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_2_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -252.65,-81.25) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_3_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_3_1_STROKES"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 113.5,47.45) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 606.7,57.45) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 94.8,369.75) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.9954376220703125, 0.0954132080078125, -0.0954132080078125, 0.9954376220703125, -344.65,-130.3) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_4_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 481.8,587.2) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 192.3,541.35) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -252.65,-81.25) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_7_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -252.65,-81.25) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_8_FILL"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.8fa97da0b3d9a56b363fe00f3f105ab0.svg";
export { ForwardRef as ReactComponent };